import * as React from "react";
import * as ReactDOM from "react-dom";
onDocumentReady(() => {
    document.querySelectorAll("[react-component]").forEach((element) => {
        var _a;
        const name = element.getAttribute("react-component");
        const props = JSON.parse((_a = element.getAttribute("react-props")) !== null && _a !== void 0 ? _a : "{}");
        const Component = () => {
            //@ts-ignore
            return React.createElement(window[name], props);
        };
        try {
            ReactDOM.render(React.createElement(Component, null), element);
        }
        catch (e) {
            console.error("Error in element", element);
            throw e;
        }
    });
});
function onDocumentReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" ||
        document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    }
    else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}
